import React from 'react';
import EditIcon from '../../assets/images/svg/editLearning.svg';
import PublishIcon from '../../assets/images/svg/publishLearning.svg';
import ArchiveIcon from '../../assets/images/svg/archiveLearning.svg';
import ArchiveEnabled from '../../assets/images/svg/archiveEnabled.svg';

// Cell style for consistent table appearance
const cellStyle = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  padding: '4px 2px',
  fontSize: '14px'
};

// Define table columns
export const tableColumns = [
  {
    name: 'ID',
    selector: row => row.ad_id,
    sortable: true,
    center: true,
    width: '120px',
    style: cellStyle,
  },
  {
    name: 'Android Ad Unit ID',
    selector: row => row.android_adv_id || '-',
    sortable: true,
    center: true,
    width: '150px',
    style: cellStyle,
    cell: row => (
      <div style={{ ...cellStyle, whiteSpace: 'normal', wordBreak: 'break-all' }}>
        {row.android_adv_id || '-'}
      </div>
    )
  },
  {
    name: 'iOS Ad Unit ID',
    selector: row => row.ios_adv_id || '-',
    sortable: true,
    center: true,
    width: '150px',
    style: cellStyle,
    cell: row => (
      <div style={{ ...cellStyle, whiteSpace: 'normal', wordBreak: 'break-all' }}>
        {row.ios_adv_id || '-'}
      </div>
    )
  },
  {
    name: 'Location',
    selector: row => row.location,
    sortable: true,
    center: true,
    width: '140px',
    style: cellStyle,
    cell: row => (
      <div style={{ 
        ...cellStyle,
        color: '#5662F6', // Blue color for location
        fontWeight: '500',
        width: '100%',
        textAlign: 'center'
      }}>
        {row.location}
      </div>
    ),
  },
  {
    name: 'Ad Type',
    selector: row => row.ad_type,
    sortable: true,
    center: true,
    width: '110px',
    style: cellStyle,
  },
  {
    name: 'Created Date',
    selector: row => row.created_date,
    sortable: true,
    center: true,
    width: '180px',
    style: cellStyle,
  },
  {
    name: 'Status',
    selector: row => row.status,
    sortable: true,
    center: true,
    // width: '18x',
    id: 'status',
    style: cellStyle,
    cell: row => (
      <span className="d-inline-block"
        style={{
          minWidth: '70px',
          textAlign: 'center',
          borderRadius: '20px',
          padding: '4px 8px',
          backgroundColor: getStatusColor(row.status),
          color: '#FFFFFF',
          fontSize: '10px',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}
      >
        {row.status}
      </span>
    )
  },
  {
    name: 'Action',
    selector: row => row.action,
    sortable: false,
    center: true,
    width: '160px',
    id: 'action',
    style: cellStyle,
  }
];

// Helper function to get status color
const getStatusColor = (status) => {
  const colorMap = {
    'New': '#FFC107',
    'Active': '#00C853',
    'Archive': '#8B5CF6'
  };
  return colorMap[status] || '#8B5CF6';
};